export const getInputErrorClassName = (error: boolean) =>
  error ? 'border-red sm:text-base md:text-sm' : 'sm:text-base md:text-sm';

export default { getInputErrorClassName };
